import { useUserLimits } from 'store/useUserLimits';
import { getUserLimits } from 'store/useUserLimits/selectors';

import { IBusinessPlanType, ILimitEntity } from 'interfaces/businessPlan';

import { getDocumentType } from 'helpers/getDocumentType';

export const useBusinessPlanTypeAvailability = (type: IBusinessPlanType) => {
  const limits = useUserLimits(getUserLimits);

  const limit = limits.availableDocumentCount[getDocumentType(type) as keyof ILimitEntity];

  const isAvailable = limit > 0;
  return { isAvailable, limit: limit < 0 ? 0 : limit };
};
